<template>
  <div>
    <div class="flex mb-5">
      <div class="w-6/12">
        <h1 class="text-xl font-bold text-gray-700">River Sections</h1>
      </div>
      <div class="w-6/12">
        <el-switch
          class="mr-5"
          v-model="withDeleted"
          active-text="Inactive"
          inactive-text="Active"
          :active-value="1"
          :inactive-value="0"
          @change="handleWithDeletedChange"
        >
        </el-switch>
        <base-button-primary @click="newRiverSection" class="float-right"
          >New River Section</base-button-primary
        >
      </div>
    </div>
    <div class="mb-3">
      <div class="w-full">
        <vue-good-table
          :columns="columns"
          :rows="riverSections"
          :search-options="{ enabled: true }"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'name', type: 'asc' },
          }"
          :fixed-header="false"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 50,
            position: 'bottom',
            perPageDropdown: [25, 50, 100],
            dropdownAllowAll: false,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'id'">
              <base-button-primary-extra-small @click="handleEdit(props.row)">
                Edit
              </base-button-primary-extra-small>

              <base-button-white-extra-small
                v-if="!props.row.deleted_at"
                @click="handleDelete(props.row)"
                class="ml-3"
              >
                Make Inactive
              </base-button-white-extra-small>
              <base-button-white-extra-small
                v-else
                @click="handleRestore(props.row)"
                class="ml-3"
              >
                Restore
              </base-button-white-extra-small>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
    <base-modal :show="showModal" @close="showModal = false" @save="save">
      <template v-slot:header> River Section </template>
      <template v-slot:main>
        <div class="grid grid-cols-2 gap-4">
          <div>
            <base-label>Name</base-label>
            <base-input v-model="riverSection.name" />
          </div>
          <div>
            <base-label>River</base-label>
            <el-select
              v-model="riverSection.river_id"
              placeholder="Select"
              class="w-full"
            >
              <el-option
                v-for="river in rivers"
                :key="river.id"
                :label="river.name"
                :value="river.id"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <base-label>Fee</base-label>
            <base-percent
              :value="riverSection.fee"
              @change="riverSection.fee = $event"
            >
            </base-percent>
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import Validator from "../common/Validator";
import BaseModal from "../ui/elements/BaseModal";
import { CurrencyDirective } from "vue-currency-input";
import currency from "../../mixins/currency";
import BasePercent from "@/components/ui/forms/BasePercent";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
export default {
  name: "RiverSections",
  components: { BasePercent, BaseModal, VueGoodTable },
  directives: {
    currency: CurrencyDirective,
  },
  mixins: [currency],
  data() {
    return {
      showModal: false,
      riverSection: {
        id: null,
        name: "",
        fee: "",
        river_id: "",
      },
      withDeleted: false,
      columns: [
        {
          label: "Name",
          field: "name",
          width: "80%",
        },
        {
          label: "",
          field: "id",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    handleWithDeletedChange() {
      this.load();
    },
    setRiverSection(row = null) {
      if (row) {
        this.riverSection = {
          id: row.id,
          name: row.name,
          fee: row.fee / 100,
          river_id: row.river_id,
        };
      } else {
        this.riverSection = {
          id: null,
          name: "",
          fee: "",
          river_id: "",
        };
      }
    },
    load() {
      this.$store.dispatch("riverSection/all", {
        withDeleted: this.withDeleted,
      });
    },
    newRiverSection() {
      this.setRiverSection();
      this.showModal = true;
    },
    handleEdit(row) {
      this.setRiverSection(row);
      this.showModal = true;
    },
    handleDelete(row) {
      if (confirm("Are you sure you want to remove this river section?")) {
        this.$store
          .dispatch("riverSection/delete_riverSection", { id: row.id })
          .then((resp) => {
            if (!resp.success) return;

            this.load();
            this.$notify({
              title: "River Section",
              message: "The river section has been removed",
              type: "success",
            });
          });
      }
    },
    handleRestore(row) {
      this.$store
        .dispatch("riverSection/restore_riverSection", { id: row.id })
        .then((resp) => {
          if (!resp.success) return;

          this.load();
          this.$notify({
            title: "River Section",
            message: "The river section has been restored",
            type: "success",
          });
        });
    },
    save() {
      if (
        !Validator([
          { field: this.riverSection.name, name: "River Section Name" },
        ])
      ) {
        return;
      }
      const data = {
        id: this.riverSection.id,
        name: this.riverSection.name,
        fee: this.riverSection.fee * 100,
        river_id: this.riverSection.river_id,
      };

      this.$store
        .dispatch("riverSection/save_riverSection", data)
        .then((resp) => {
          if (!resp.success) return;

          this.load();
          this.$notify({
            title: "River Section",
            message: "Data Saved",
            type: "success",
          });
          this.showModal = false;
          this.setRiverSection();
        });
    },
  },
  computed: {
    riverSections: function () {
      return this.$store.getters["riverSection/getRiverSections"];
    },
    rivers: function () {
      return this.$store.getters["river/getRivers"];
    },
  },
  mounted() {
    this.load();
    this.$store.dispatch("river/all", { withDeleted: 0 });
  },
};
</script>

<style scoped></style>
